// extracted by mini-css-extract-plugin
module.exports = {"gift-pack":"WQqwlHohQZ","button-style":"_1vPAbhM6Ag","table-style":"_3pHlQDn04a","tip-style":"_1HF1nm_uv9"};